import React, { createContext, useState } from "react";

const ChecklistContext = createContext();

const ChecklistProvider = ({ children }) => {
  const [sectionIdGlobal, setSectionIdGlobal] = useState(0);
  const [subSectionIdGlobal, setSubSectionIdGlobal] = useState(0);
  const [childSubSectionIdGlobal, setChildSubSectionIdGlobal] = useState(0);
  const [recentlySavedQuestion, setRecentlySavedQuestion] = useState({
    id: 0,
    index: 0,
    text: "",
  });
  const [refreshCollection, setRefreshCollection] = useState(false);
  const [refreshSubSections, setRefreshSubSections] = useState(false);

  return (
    <ChecklistContext.Provider
      value={{
        sectionIdGlobal,
        setSectionIdGlobal,
        subSectionIdGlobal,
        setSubSectionIdGlobal,
        childSubSectionIdGlobal,
        setChildSubSectionIdGlobal,
        recentlySavedQuestion,
        setRecentlySavedQuestion,
        setRefreshCollection,
        refreshCollection,
        refreshSubSections,
        setRefreshSubSections,
      }}
    >
      {children}
    </ChecklistContext.Provider>
  );
};

export { ChecklistContext, ChecklistProvider };
